import ChartBuilder from './chart_builder'

export default {
  setup() {
    const defaultOptions = {
      cutout: '65%', // per Marcelo's design for all doughnut charts
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false // Marcelo wants custom legends (in flex boxes)
        },
        // Set the Tooltip to default display the percentage values
        // TODO: Rework this into an External Custom Tooltip leveraging HTMl
        tooltip: {
          backgroundColor: '#fff',
          bodyColor: '#00000099',
          bodyFont: {
            size: 14
          },
          bodyFontSize: 14,
          bodySpacing: 8,
          borderColor: '#cecece',
          borderWidth: 1,
          boxPadding: 8,
          padding: 16,
          position: 'nearest',
          titleColor: '#5E5E5E',
          titleFont: { size: 12, weight: 'normal' },
          titleMarginBottom: 14,
          usePointStyle: true,
          callbacks: {
            title: function (context) {
              return context[0].label
            },
            label: (ctx) => {
              const dataset = ctx.dataset
              const total = dataset.data.reduce(
                (previousValue, currentValue, currentIndex, array) => {
                  return previousValue + currentValue
                }
              )
              const currentValue = dataset.data[ctx.dataIndex]
              const percentage = Math.floor((currentValue / total) * 100 + 0.5)
              return ' ' + percentage + '%'
            }
          }
        }
      }
    }
    const data = JSON.parse(this.el.dataset.chartData)
    const options = JSON.parse(this.el.dataset.chartOptions || '{}')
    this.chart = new ChartBuilder(
      this.el,
      'doughnut',
      data,
      defaultOptions,
      options
    ).chart
  },
  destroy() {
    this.chart?.destroy()
    this.chart = null
  },
  mounted() {
    this.setup()
  },
  updated() {
    ChartBuilder.refresh_data(this)
  },
  destroyed() {
    this.destroy()
  }
}
